var obj_user = {
        token_user: null,
        usuarioLogado: function () {

                if (window.sessionStorage.getItem("socv2_user") != null)
                        return true;

                return false;
        },
        setUsuario: function (obj) {
                if (window.sessionStorage.getItem("socv2_user") != null) {
                        window.sessionStorage.removeItem("socv2_user");
                }

                window.sessionStorage.setItem("socv2_user", obj);
        },
        setUser: function (obj) {
                this.setUsuario(obj);
        },
        getUser: function () {
                return window.sessionStorage.getItem("socv2_user");
        }
}

window.obj_user = obj_user;


//export default { obj_user };